export * from '@unifyapps/analytics-web';

export const getIsScreenActive = () => {
  return !document?.hidden;
};
